<script setup>
import { useCurrency } from '@/composables/useCurrency'
import RentalStatusPill from '@/Components/UI/RentalStatusPill.vue'
import DepositStatusPill from '@/Components/UI/DepositStatusPill.vue'
import { useI18n } from 'vue-i18n'

defineProps({ rental: { type: Object, required: true } })
const { t } = useI18n()
const { formatMoney, formatDate } = useCurrency()
</script>

<template>
  <div class="space-y-2">
    <!-- Top row: status + customer + total -->
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <div class="flex items-center gap-2">
          <RentalStatusPill :status="rental.status" />
        </div>
        <div class="mt-1.5 truncate text-[color:var(--ink)] font-medium">
          {{ rental.customer_name || t('rentals.card.unknownCustomer') }}
        </div>
      </div>
      <div
        v-if="rental.status !== 'cancelled'"
        class="shrink-0 text-right"
      >
        <div class="fw-value tabular-nums text-[color:var(--ink)]">
          {{ formatMoney(rental.rental_paid_cents || 0) }}
        </div>
        <div class="mt-0.5 text-[10px] uppercase tracking-wide text-[color:var(--muted)]">
          {{ t('rentals.card.paid') }}
        </div>
      </div>
      <div
        v-else
        class="shrink-0 text-[color:var(--muted)]"
      >
        —
      </div>
    </div>

    <!-- Vehicle + dates -->
    <div class="flex items-baseline justify-between gap-3 text-sm">
      <span class="min-w-0 truncate text-[color:var(--inkSoft)]">
        <template v-if="rental.vehicle_name">
          {{ rental.vehicle_name }}<template v-if="rental.vehicle_reg"> · {{ rental.vehicle_reg }}</template>
        </template>
        <template v-else>—</template>
      </span>
      <span class="shrink-0 tabular-nums text-xs text-[color:var(--muted)]">
        {{ formatDate(rental.start_at) }} → {{ formatDate(rental.expected_end_at) }}
      </span>
    </div>

    <!-- Deposit pill -->
    <div
      v-if="rental.status !== 'cancelled'"
      class="flex items-center gap-2 text-xs"
    >
      <DepositStatusPill :status="rental.deposit_status" />
    </div>
  </div>
</template>
